import React, { useState } from "react";
import { Apple, Download, Smartphone } from "lucide-react";
import AppDownloadLink from "./AppDownloadLink";
import { detectDevice, isStandalone } from "../../hooks/useInstallPrompt";

const SUB = { android: "For Android · Free", ios: "For iPhone · Free", desktop: "Android & iPhone · Free" };
const ICON = { android: Download, ios: Apple, desktop: Smartphone };

// Big front-page download button under the prompt box.
export const HeroDownloadButton = () => {
  const [device] = useState(detectDevice);
  if (isStandalone()) return null;
  const Icon = ICON[device];
  return (
    <AppDownloadLink source="hero_button" device={device} testid="hero-download-app-btn"
      className="group inline-flex items-center gap-3 h-14 pl-2 pr-6 rounded-full bg-slate-900 text-white shadow-[0_16px_40px_-16px_rgba(15,23,42,0.6)] hover:bg-slate-800 hover:-translate-y-0.5 transition-[transform,background-color] duration-200">
      <span className="w-10 h-10 rounded-full bg-sky-500 flex items-center justify-center transition-transform duration-200 group-hover:scale-110"><Icon size={19} /></span>
      <span className="text-left leading-tight">
        <span className="block text-base font-semibold font-display">Download the app</span>
        <span className="block text-[11px] text-slate-300">{SUB[device]}</span>
      </span>
    </AppDownloadLink>
  );
};

export default HeroDownloadButton;
